import { Box, Collapse } from '@mui/material';
import AgentModelInfo from './AgentModelInfo';
import TokenUsageCost from './TokenUsageCost';
import ToolUsageStats from './ToolUsageStats';
import DeviceInfo from './DeviceInfo';
import ErrorDetails from './ErrorDetails';

interface ExecutionDetailsPanelProps {
  expanded: boolean;
  agentName?: string;
  modelName?: string;
  provider?: string;
  inputTokens?: number;
  outputTokens?: number;
  costUsd?: number;
  toolCalls?: { name: string; count: number }[];
  totalToolCalls?: number;
  deviceInfo?: {
    hostname?: string;
    cpuLoad?: number;
    latencyMs?: number;
  };
  executionStatus?: 'pending' | 'running' | 'retrying' | 'failed' | 'completed';
  errorMessage?: string;
}

export default function ExecutionDetailsPanel({
  expanded,
  agentName,
  modelName,
  provider,
  inputTokens,
  outputTokens,
  costUsd,
  toolCalls,
  totalToolCalls,
  deviceInfo,
  executionStatus,
  errorMessage,
}: ExecutionDetailsPanelProps) {
  const isFailedExecution = executionStatus === 'failed';

  return (
    <Collapse in={expanded}>
      <Box
        sx={{
          mt: 2,
          pt: 2,
          borderTop: 1,
          borderColor: 'rgba(255, 255, 255, 0.2)',
        }}
      >
        <AgentModelInfo agentName={agentName} modelName={modelName} provider={provider} />
        <TokenUsageCost inputTokens={inputTokens} outputTokens={outputTokens} costUsd={costUsd} />
        <ToolUsageStats toolCalls={toolCalls} totalToolCalls={totalToolCalls} />
        <DeviceInfo deviceInfo={deviceInfo} />
        {isFailedExecution && <ErrorDetails errorMessage={errorMessage} />}
      </Box>
    </Collapse>
  );
}
